import { EventType } from '@/analytics/types';
import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const metabolicHealthFeaturesData: LandingPageFeature[] = [
  {
    id: 'score',
    title: 'metabolic_health_features_meals_header',
    description: 'metabolic_health_features_meals_copy',
    image: {
      format: 'png',
      localizedAlt: 'dexcom_app_ui_alt_key',
      src: 'oura_advisor_metabolic_app_ui.png',
    },
  },
  {
    id: 'automatic',
    title: 'metabolic_health_features_glucose_header',
    description: 'metabolic_health_features_glucose_subcopy',
    image: {
      format: 'png',
      localizedAlt: 'dexcom_app_ui_alt_key',
      src: 'meatbolic_health_features_2.png',
    },
    button: {
      href: '/store/dexcom/stelo-glucose-biosensor',
      label: 'shop_stelo',
      onClick: () => {
        void window.ouraAnalytics.track(EventType.CTAClicked, {
          action: 'shop stelo',
          cta: 'Shop Stelo',
          location: 'features tab',
          path: '/store/dexcom/stelo-glucose-biosensor',
        });
      },
    },
  },
];

export default metabolicHealthFeaturesData;
